module.exports = "/_next/static/images/17-1-cc33ae418a497a74f4b7f73c7c2f14df.svg";